import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";

import { MdOutlineLocalPrintshop, MdOutlineFactCheck, MdOutlineSend, MdOutlineTextIncrease, MdOutlineTextDecrease, MdOutlineFileDownload, MdCheckBoxOutlineBlank } from "react-icons/md";
import { AiOutlineAppstoreAdd } from "react-icons/ai";

import './css/view.css'

import { AppContext } from "../../Context";
import { Loader, GET, permissions } from "../../inc/Fetch"; 
import Header from "./Header";
import Student_tasks from "./components/Student_tasks";
import Teachers_tasks from "./components/Teachers_tasks";
import Teachers_task_info from "./components/Teachers_task_info";
import Permission from '../Permission'
import Teachers_games from './components/Teachers_games';
import Teachers_games_info from './components/Teachers_games_info';

export default function MyGames({action}) {

    const { t } = useTranslation();
    let location = useLocation();
    let params = useParams();

    const { userData } = useContext(AppContext);
    const [userinfo, setuserinfo] = userData;

    const [show, setshow] = useState(0);
    
    if (userinfo?.userlevel < 3) {
            return <Permission />
        } else {
                
        let perms = permissions(userinfo, params?.id, "games");
        if (!perms) {
            return <Permission />
        }
            
    }

    return (
        <>
            <div className='taskNewBody'>
                
                <Header />
                
                {userinfo?.userlevel >= 3 &&
                    <>
                        {params?.id ? 
                            <Teachers_games_info />
                        :
                            <Teachers_games />
                        }
                    </>
                
                }
                
               
            </div>
        </>
    )
}
